export const getErrorMessage = (message: string) => {
  switch (message) {
    case "Object with one or more passed fields (required as unique) already exist":
      return "WRF Firmware Version with such name already exists.";
    case "field required":
      return "Some fields are missing.";
    default:
      return message;
  }
};
